<div class="bgv">
  <div class="containers">
    <div class="main">
      <form [formGroup]="portForm">
        <div class="requiredFeilds" [ngClass]="{ 'dark-filter': isDarkMode() }">
          <div class="required">
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Name of Ship'"
                  [formSubmitted]="formSubmitted"
                  required="true"
                  [controlname]="this.portForm.controls['ship_name']"
                  [errorMessage]="'Ship Name is required.'"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <label for="portName" class="portName" [ngClass]="{ 'dark-label': isDarkMode() }"
                  ><span class="asterik-color" *ngIf="required">*</span>Port
                  Name</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="portName"
                  placeholder="Enter Port Name"
                  formControlName="port_name"
                  [matAutocomplete]="auto"
                  [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      portForm.get('port_name')?.hasError('required')
                  }"
                />
               <mat-autocomplete #auto="matAutocomplete">
  <!-- Skeleton Loading State for Autocomplete -->
  <mat-option *ngIf="isLoadingPorts" disabled class="skeleton-option">
    <div class="skeleton-bar" style="width: 70%; height: 14px;"></div>
  </mat-option>
  <mat-option *ngIf="isLoadingPorts" disabled class="skeleton-option">
    <div class="skeleton-bar" style="width: 50%; height: 14px;"></div>
  </mat-option>

  <!-- Real Data State -->
  <ng-container *ngIf="!isLoadingPorts">
    <mat-option
      *ngFor="let suggestion of filteredPortNameSuggestions"
      [value]="suggestion.port_name"
      (onSelectionChange)="onSelectPort(suggestion)"
    >
      {{ suggestion.port_name }}
    </mat-option>
  </ng-container>
</mat-autocomplete>
                <small
                  class="error"
                  *ngIf="
                    formSubmitted &&
                    portForm.get('port_name')?.hasError('required')
                  "
                >
                  Port Name is required.
                </small>
              </div>
            </div>
            <br />
            <mat-slide-toggle
              formControlName="atSea"
              [checked]="checked"
              (change)="onToggleChange()"
              ><span class="label" [ngClass]="{ 'dark-label': isDarkMode() }">At Sea Position</span></mat-slide-toggle
            >
            <br /><br />
            <div class="row">
              <div class="col-md-6">
                <label for="" class="labelHead" [ngClass]="{ 'dark-label': isDarkMode() }">Latitude:</label>
                <div class="row">
                  <div class="col-md-4">
                    <app-custom-input
                      [label]="'Degree(0-90)'"
                      [controlname]="this.portForm.controls['la_Degree']"
                      [required]="toggle"
                      [formSubmitted]="formSubmitted"
                      (onInput)="onInputChange($event, 'la_Degree')"
                      [errorMessage]="'Degree is required.'"
                      [readonly]="!toggle"
                    ></app-custom-input>
                  </div>
                  <div class="col-md-4">
                    <app-custom-input
                      [label]="'Minutes(0-60)'"
                      [controlname]="this.portForm.controls['la_Min']"
                      (onInput)="onInputChange($event, 'la_Min')"
                      [required]="toggle"
                      [formSubmitted]="formSubmitted"
                      [errorMessage]="'Minutes is required.'"
                      [readonly]="!toggle"
                    ></app-custom-input>
                  </div>
                  <div class="col-md-4">
                    <app-custom-dropdown
                      [items]="laDirection"
                      label="Direction"
                      [required]="toggle"
                      [formSubmitted]="formSubmitted"
                      (onSelectedChanged)="onInputChange($event, 'la_Dir')"
                      [controlname]="this.portForm.controls['la_Dir']"
                    ></app-custom-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label for="" class="labelHead" [ngClass]="{ 'dark-label': isDarkMode() }">Longitude:</label>
                <div class="row">
                  <div class="col-md-4">
                    <app-custom-input
                      [label]="'Degree(0-180)'"
                      [controlname]="this.portForm.controls['lo_Degree']"
                      (onInput)="onInputChange($event, 'lo_Degree')"
                      [required]="toggle"
                      [formSubmitted]="formSubmitted"
                      [errorMessage]="'Degree is required.'"
                      [readonly]="!toggle"
                    ></app-custom-input>
                  </div>
                  <div class="col-md-4">
                    <app-custom-input
                      [label]="'Minutes(0-60)'"
                      [controlname]="this.portForm.controls['lo_Min']"
                      (onInput)="onInputChange($event, 'lo_Min')"
                      [required]="toggle"
                      [formSubmitted]="formSubmitted"
                      [errorMessage]="'Minutes is required.'"
                      [readonly]="!toggle"
                    ></app-custom-input>
                  </div>
                  <div class="col-md-4">
                    <app-custom-dropdown
                      [items]="loDirection"
                      label="Direction"
                      [formSubmitted]="formSubmitted"
                      [required]="toggle"
                      [controlname]="this.portForm.controls['lo_Dir']"
                      (onSelectedChanged)="onInputChange($event, 'lo_Dir')"
                    ></app-custom-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <!-- <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'Latitude:'"
                [controlname]="this.portForm.controls['port_lat']"
                required="true"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'Latitude is required.'"
              ></app-custom-input>
              <div *ngIf="portForm.get('port_lat')?.hasError('pattern')">
                <small class="error">Invalid latitude format</small>
              </div>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Longitude:'"
                required="true"
                [formSubmitted]="formSubmitted"
                [controlname]="this.portForm.controls['port_lng']"
                [errorMessage]="'Longitude is required.'"
              ></app-custom-input>
              <div *ngIf="portForm.get('port_lng')?.hasError('pattern')">
                <small class="error">Invalid longitude format</small>
              </div>
            </div>
          </div> -->
          </div>

          <div class="required">
            <div class="row">
              <div class="col-md-6">
                <app-custom-date-picker
                  [label]="'Report Start Date'"
                  [controlname]="this.portForm.controls['start_date']"
                ></app-custom-date-picker>
              </div>
              <div class="col-md-6">
                <app-custom-dropdown
                  [items]="days"
                  label="Number of Days"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.portForm.controls['days']"
                ></app-custom-dropdown>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-6">
                <app-custom-dropdown
                  [items]="splitHours"
                  label="Frequency(Hours)"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.portForm.controls['hours_split']"
                ></app-custom-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="text-left">
              <button
                class="btn btn-light hover-button mail"
                (click)="clearClick()"
              >
                <mat-icon>clear_all</mat-icon> &nbsp;Clear
              </button>

              <button
                class="btn btn-light hover-button mail"
                (click)="submitClick()"
              >
                <mat-icon>done</mat-icon> Submit
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-right">
              <button
                class="btn btn-light hover-button request"
                (click)="myRequestClick()"
              >
                <mat-icon>assignment</mat-icon> My Requests
              </button>
              <!-- <button
                class="btn btn-light hover-button mail"
                (click)="downloadClick()"
                [disabled]="true"
              >
                <mat-icon>download</mat-icon>&nbsp; Download
              </button> -->
              <button
                class="btn btn-light hover-button mail"
                (click)="emailClick()"
              >
                <mat-icon>mail</mat-icon>&nbsp; E-Mail
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>